import baseMeme1 from "../../assets/images/baseMeme1.jpg";
import baseMeme10 from "../../assets/images/baseMeme10.jpg";
import baseMeme11 from "../../assets/images/baseMeme11.jpg";
import baseMeme12 from "../../assets/images/baseMeme12.jpg";
import baseMeme14 from "../../assets/images/baseMeme14.jpg";
import baseMeme15 from "../../assets/images/baseMeme15.jpg";
import baseMeme16 from "../../assets/images/baseMeme16.jpg";
import baseMeme17 from "../../assets/images/baseMeme17.jpg";
import baseMeme2 from "../../assets/images/baseMeme2.jpg";
import baseMeme3 from "../../assets/images/baseMeme3.jpg";
import baseMeme4 from "../../assets/images/baseMeme4.jpg";
import baseMeme5 from "../../assets/images/baseMeme5.jpg";
import baseMeme6 from "../../assets/images/baseMeme6.jpg";
import baseMeme7 from "../../assets/images/baseMeme7.jpg";
import baseMeme8 from "../../assets/images/baseMeme8.jpg";
import baseMeme9 from "../../assets/images/baseMeme9.jpg";

import baseMeme10thumb from "../../assets/images/baseMeme10thumb.jpg";
import baseMeme11thumb from "../../assets/images/baseMeme11thumb.jpg";
import baseMeme12thumb from "../../assets/images/baseMeme12thumb.jpg";
import baseMeme14thumb from "../../assets/images/baseMeme14thumb.jpg";
import baseMeme15thumb from "../../assets/images/baseMeme15thumb.jpg";
import baseMeme16thumb from "../../assets/images/baseMeme16thumb.jpg";
import baseMeme17thumb from "../../assets/images/baseMeme17thumb.jpg";
import baseMeme1thumb from "../../assets/images/baseMeme1thumb.jpg";
import baseMeme2thumb from "../../assets/images/baseMeme2thumb.jpg";
import baseMeme3thumb from "../../assets/images/baseMeme3thumb.jpg";
import baseMeme4thumb from "../../assets/images/baseMeme4thumb.jpg";
import baseMeme5thumb from "../../assets/images/baseMeme5thumb.jpg";
import baseMeme6thumb from "../../assets/images/baseMeme6thumb.jpg";
import baseMeme7thumb from "../../assets/images/baseMeme7thumb.jpg";
import baseMeme8thumb from "../../assets/images/baseMeme8thumb.jpg";
import baseMeme9thumb from "../../assets/images/baseMeme9thumb.jpg";

const presetMeme = [
  {
    id: 1,
    src: baseMeme1,
    thumb: baseMeme1thumb,
    useText: 2,

    text1: "Make a meme\nwith Photoshop",
    top1: 18,
    left1: 26,
    size1: 1.6,
    color1: "#333333",
    border1: 0,
    borderColor1: "#333333",
    alignText1: "center",

    text2: "Make a meme\nwith code",
    top2: 70,
    left2: 26,
    size2: 1.6,
    color2: "#333333",
    border2: 0,
    borderColor2: "#333333",
    alignText2: "center",

    textOutside: false,
    imageSelected: null,
  },
  {
    id: 2,
    src: baseMeme2,
    thumb: baseMeme2thumb,
    useText: 4,
    text1: "Frontend Dev",
    top1: 40,
    left1: -34,
    size1: 1.5,
    color1: "#ffffff",
    border1: 0,
    borderColor1: "#333333",
    alignText1: "center",

    text2: "Backend Dev",
    top2: 25,
    left2: 35,
    size2: 1.6,
    color2: "#ffffff",
    border2: 0,
    borderColor2: "#333333",
    alignText2: "center",

    text3: "JSON",
    top3: 31,
    left3: 2,
    size3: 3,
    color3: "#ffffff",
    border3: 0,
    borderColor3: "#333333",
    alignText3: "center",

    text4: "Fullstack Dev",
    top4: 87,
    left4: -6,
    size4: 2,
    color4: "#ffffff",
    border4: 0,
    borderColor4: "#333333",
    alignText4: "center",

    textOutside: false,
    imageSelected: null,
  },
  {
    id: 3,
    src: baseMeme3,
    thumb: baseMeme3thumb,
    useText: 3,

    text1: "Full stack developer",
    top1: 32,
    left1: 2,
    size1: 1.8,
    color1: "#ffffff",
    alignText1: "center",

    text2: "Full stack developer",
    top2: 69,
    left2: 2,
    size2: 1.3,
    color2: "#ffffff",
    alignText2: "center",

    text3: "CHAT GPT",
    top3: 80,
    left3: 27,
    size3: 2.1,
    color3: "#333333",
    alignText3: "center",

    textOutside: false,
    imageSelected: null,
  },
  {
    id: 4,
    src: baseMeme4,
    thumb: baseMeme4thumb,
    useText: 2,

    text1: "HTML",
    top1: 41,
    left1: 1.5,
    size1: 2,
    color1: "#ffffff",
    border1: 0,
    borderColor1: "#333333",
    alignText1: "center",

    text2: "CSS",
    top2: 93,
    left2: 1.4,
    size2: 2,
    color2: "#ffffff",
    border2: 0,
    borderColor2: "#333333",
    alignText2: "center",

    textOutside: false,
    imageSelected: null,
  },
  {
    id: 5,
    src: baseMeme5,
    thumb: baseMeme5thumb,
    useText: 3,

    text1: "New side project",
    top1: 69,
    left1: -26,
    size1: 1.8,
    color1: "#333333",
    border1: 0,
    borderColor1: "#333333",
    alignText1: "center",

    text2: "ME",
    top2: 46,
    left2: 14,
    size2: 2.7,
    color2: "#ffffff",
    border2: 1,
    borderColor2: "#333333",
    alignText2: "center",

    text3: "Unfinished\nprojects",
    top3: 70,
    left3: 35,
    size3: 1.9,
    color3: "#ffffff",
    border3: 1,
    borderColor3: "#333333",
    alignText3: "center",

    textOutside: false,
    imageSelected: null,
  },
  {
    id: 6,
    src: baseMeme6,
    thumb: baseMeme6thumb,
    useText: 2,

    text1: "I and J\nin alphabet",
    top1: 19,
    left1: -26,
    size1: 2,
    color1: "#000000",
    border1: 0,
    borderColor1: "#333333",
    alignText1: "center",

    text2: "I and J\nin programming",
    top2: 69,
    left2: -26,
    size2: 2,
    color2: "#000000",
    border2: 0,
    borderColor2: "#333333",
    alignText2: "center",

    textOutside: false,
    imageSelected: null,
  },
  {
    id: 7,
    src: baseMeme7,
    thumb: baseMeme7thumb,
    useText: 2,

    text1: "What is your job?",
    top1: 46,
    left1: -24,
    size1:1.8,
    color1: "#fff",
    border1: 0,
    borderColor1: "#333333",
    alignText1: "center",

    text2: "I'm a programmer",
    top2: 33,
    left2: 24,
    size2: 1.8,
    color2: "#fff",
    border2: 0,
    borderColor2: "#333333",
    alignText2: "center",

    textOutside: false,
    imageSelected: null,
  },
  {
    id: 8,
    src: baseMeme8,
    thumb: baseMeme8thumb,
    useText: 3,

    text1: "Frontend",
    top1: 14,
    left1: 47,
    size1: 2,
    color1: "#000000",
    border1: 0,
    borderColor1: "#333333",
    alignText1: "left",

    text2: "Backend",
    top2: 47,
    left2: 47,
    size2: 2,
    color2: "#000000",
    border2: 0,
    borderColor2: "#333333",
    alignText2: "left",

    text3: "Weekend",
    top3: 80,
    left3: 47,
    size3: 2,
    color3: "#000000",
    border3: 0,
    borderColor3: "#333333",
    alignText3: "left",

    textOutside: false,
    imageSelected: null,
  },
  {
    id: 9,
    src: baseMeme9,
    thumb: baseMeme9thumb,
    useText: 2,

    text1: "My debugging",
    top1: 6,
    left1: -26,
    size1: 2,
    color1: "#000000",
    border1: 0,
    borderColor1: "#333333",
    alignText1: "center",

    text2: "The bug",
    top2: 8,
    left2: 28,
    size2: 2,
    color2: "#000000",
    border2: 0,
    borderColor2: "#333333",
    alignText2: "center",

    textOutside: false,
    imageSelected: null,
  },
  {
    id: 10,
    src: baseMeme10,
    thumb: baseMeme10thumb,
    useText: 3,

    text1: "var",
    top1: 12,
    left1: 52,
    size1: 2,
    color1: "#000000",
    border1: 0,
    borderColor1: "#333333",
    alignText1: "left",

    text2: "let",
    top2: 45,
    left2: 52,
    size2: 2,
    color2: "#000000",
    border2: 0,
    borderColor2: "#333333",
    alignText2: "left",

    text3: "const",
    top3: 79,
    left3: 52,
    size3: 2,
    color3: "#000000",
    border3: 0,
    borderColor3: "#333333",
    alignText3: "left",

    textOutside: false,
    imageSelected: null,
  },
  {
    id: 11,
    src: baseMeme11,
    thumb: baseMeme11thumb,
    useText: 2,

    text1: "bug",
    top1: 19,
    left1: -26,
    size1: 2,
    color1: "#000000",
    border1: 0,
    borderColor1: "#333333",
    alignText1: "center",

    text2: "feature",
    top2: 68,
    left2: -23,
    size2: 2,
    color2: "#000000",
    border2: 0,
    borderColor2: "#333333",
    alignText2: "center",

    textOutside: false,
    imageSelected: null,
  },
  {
    id: 12,
    src: baseMeme12,
    thumb: baseMeme12thumb,
    useText: 2,

    text1: "first hour of programming",
    top1: 5,
    left1: -25,
    size1: 1.4,
    color1: "#000000",
    border1: 0,
    borderColor1: "#333333",
    alignText1: "center",

    text2: "after 4 hour",
    top2: 4,
    left2: 22,
    size2: 1.8,
    color2: "#ff0000",
    border2: 0,
    borderColor2: "#333333",
    alignText2: "center",

    textOutside: false,
    imageSelected: null,
  },
  {
    id: 14,
    src: baseMeme14,
    thumb: baseMeme14thumb,
    useText: 6,

    text1: "Designers",
    top1: 4,
    left1: 1,
    size1: 1.8,
    color1: "#000000",
    border1: 0,
    borderColor1: "#333333",
    alignText1: "center",

    text2: "Look, we have a similar idea.",
    top2: 44,
    left2: -24,
    size2: 1,
    color2: "#333333",
    border2: 0,
    borderColor2: "#333333",
    alignText2: "center",

    text3: "No you stole my idea.",
    top3: 44,
    left3: 27,
    size3: 1,
    color3: "#333333",
    border3: 0,
    borderColor3: "#333333",
    alignText3: "center",

    text4: "Programmers",
    top4: 52,
    left4: 1,
    size4: 1.8,
    color4: "#333333",
    border4: 0,
    borderColor4: "#333333",
    alignText4: "center",

    text5: "Man I stole your code.",
    top5: 93,
    left5: -25,
    size5: 1,
    color5: "#333333",
    border5: 0,
    borderColor5: "#333333",
    alignText5: "center",

    text6: "It's not my code",
    top6: 93,
    left6: 27,
    size6: 1,
    color6: "#333333",
    border6: 0,
    borderColor6: "#333333",
    alignText6: "center",

    textOutside: false,
    imageSelected: null,
  },
  {
    id: 15,
    src: baseMeme15,
    thumb: baseMeme15thumb,
    useText: 3,

    text1: "Backend",
    top1: 4,
    left1: 1,
    size1: 1.8,
    color1: "#ffffff",
    border1: 0,
    borderColor1: "#333333",
    alignText1: "center",

    text2: "Frontend",
    top2: 36,
    left2: 1,
    size2: 1.8,
    color2: "#ffffff",
    border2: 0,
    borderColor2: "#333333",
    alignText2: "center",

    text3: "Api",
    top3: 93,
    left3: 1,
    size3: 1.8,
    color3: "#ffffff",
    border3: 0,
    borderColor3: "#333333",
    alignText3: "center",

    textOutside: false,
    imageSelected: null,
  },

  {
    id: 16,
    src: baseMeme16,
    thumb: baseMeme16thumb,
    useText: 3,

    text1: "Backend",
    top1: 1,
    left1: -39,
    size1: 1.8,
    color1: "#333333",
    border1: 0,
    borderColor1: "#333333",
    alignText1: "center",

    text2: "Frontend",
    top2: 1,
    left2: 39,
    size2: 1.8,
    color2: "#333333",
    border2: 0,
    borderColor2: "#333333",
    alignText2: "center",

    text3: "Internal server error",
    top3: 70,
    left3: 14,
    size3: 1,
    color3: "#ff0000",
    border3: 0,
    borderColor3: "#333333",
    alignText3: "center",

    textOutside: false,
    imageSelected: null,
  },

  {
    id: 17,
    src: baseMeme17,
    thumb: baseMeme17thumb,
    useText: 6,

    text1: "Today",
    top1: 4,
    left1: -37,
    size1: 1.8,
    color1: "#333333",
    border1: 0,
    borderColor1: "#333333",
    alignText1: "center",

    text2: "Programmer",
    top2: 17,
    left2: 3,
    size2: 1.4,
    color2: "#333333",
    border2: 0,
    borderColor2: "#333333",
    alignText2: "center",

    text3: "Ai",
    top3: 35,
    left3: -19,
    size3: 1.8,
    color3: "#ffffff",
    border3: 0,
    borderColor3: "#333333",
    alignText3: "center",

    text4: "Tomorrow",
    top4: 57,
    left4: -34,
    size4: 1.8,
    color4: "#333333",
    border4: 0,
    borderColor4: "#333333",
    alignText4: "center",

    text5: "Programmer",
    top5: 90,
    left5: 14,
    size5: 1,
    color5: "#333333",
    border5: 0,
    borderColor5: "#333333",
    alignText5: "center",

    text6: "Ai",
    top6: 66,
    left6: 23,
    size6: 3.3,
    color6: "#ffffff",
    border6: 0,
    borderColor6: "#333333",
    alignText6: "center",

    textOutside: false,
    imageSelected: null,
  },
];
export default presetMeme;
